<div class="cg-clearfix">
  <div class="content-rail">
    <form
      action="/pkmslogin.form"
      id="login-form"
      method="POST"
      ngNoForm
      (submit)="submit()"
    >
      <input type="hidden" name="login-form-type" value="pwd" />
      <h1>{{ 'login.form.header' | translate }}</h1>

      <div class="cg-field-container">
        <div class="cg-margin-bottom-sm">
          <a
            tabindex="-1"
            class="forgot-link"
            data-test="forgot-userid-link"
            routerLink="/identity/forgot/userid"
            >{{ 'login.form.forgotUsername' | translate }}</a
          >
          <label for="username">{{ 'login.form.username' | translate }}</label>
        </div>
        <div>
          <input
            type="text"
            name="username"
            id="username"
            [formControl]="username"
            data-test="username"
            cignaInput
            cignaTrimInputWhitespace
          />
        </div>
        <div
          *ngIf="
            (status !== 'wamerror' &&
              status !== 'nowam' &&
              username.invalid &&
              username.touched) ||
            (username.invalid && username.dirty)
          "
          class="cg-error-msg"
        >
          <cigna-icon type="exclamation-circle"></cigna-icon>
          <span>{{ 'login.form.validationUsername' | translate }}</span>
        </div>
      </div>
      <div>
        <div class="cg-margin-bottom-sm">
          <a
            tabindex="-1"
            class="forgot-link"
            data-test="forgot-password-link"
            routerLink="/identity/forgot/password"
            >{{ 'login.form.forgotPassword' | translate }}</a
          >
          <label for="password">{{ 'login.form.password' | translate }}</label>
        </div>

        <div class="cg-input-container">
          <input
            name="password"
            id="password"
            type="password"
            [formControl]="password"
            data-test="password"
            cignaInput
            cignaTrimInputWhitespace
            maxlength="64"
          />
        </div>

        <div
          *ngIf="
            (status !== 'wamerror' &&
              status !== 'nowam' &&
              password.invalid &&
              password.touched) ||
            (password.invalid && password.dirty)
          "
          class="cg-error-msg"
        >
          <cigna-icon type="exclamation-circle"></cigna-icon>
          <span>{{ 'login.form.validationPassword' | translate }}</span>
        </div>
      </div>
      <div
        *ngIf="status === 'wamerror' || status === 'nowam'"
        class="cg-error-msg"
        style="display: block"
        data-test="wam-message"
      >
        <!-- Has WAM messaging -->
        <ng-container *ngIf="status === 'wamerror'">
          Account not activated. Contact your
          <a (click)="openWamFaqModal(true)">website access manager.</a>
        </ng-container>
        <!-- No WAM messaging -->
        <ng-container *ngIf="status === 'nowam'">
          TIN's access has not been activated.
          <a (click)="openWamFaqModal(false)">Learn more.</a>
        </ng-container>
      </div>
      <div class="cg-margin-top-xl">
        <button
          class="full-width-button"
          [disabled]="submitted"
          cignaButton="primary"
          type="submit"
          data-test="login-submit-button"
          value="Login"
        >
          {{ 'login.form.login' | translate }}
        </button>
        <h5 class="centered-pipe-text">
          {{ 'login.form.createdAccount' | translate }}
        </h5>
        <a
          class="full-width-button"
          routerLink="/registration"
          cignaButton="secondary"
          data-test="register-button"
          [cignaTrackClicks]="[
            'trackEventOther',
            'Register',
            'ac-Reg011-Registration Type',
            {
              eVar101: 'Registration:Standard'
            }
          ]"
        >
          {{ 'login.form.register' | translate }}</a
        >

        <!-- <div
          *ngIf="submitted"
          style="display:inline-block;"
          class="cg-margin-left-md"
        >
          <div class="cg-media">
            <div class="cg-media__img"><div class="cg-spinner"></div></div>
            <div class="cg-media__bd cg-margin-top-xs cg-margin-left-sm"></div>
          </div>
        </div> -->
      </div>

      <div class="login-form-footer">
        <div class="cg-margin-bottom-sm">
          <a
            class="cg-margin-left-xl"
            routerLink="/registration/tempid"
            [cignaTrackClicks]="[
              'trackEventOther',
              'I have a temporary ID',
              'ac-Login006-US1023757-Temporary ID',
              {
                eVar101: 'Registration:Temp ID'
              }
            ]"
            data-test="login-tempid-link"
          >
            {{ 'login.form.tempId' | translate }}</a
          >

          <button
            cignaButton="link"
            type="button"
            (click)="openWhatIsTemporaryIdModal()"
            [cignaTrackClicks]="[
              'trackEventOther',
              'What is a temporary ID',
              'ac-Login038-US1023757-Temporary ID'
            ]"
            data-test="login-tempid-help-link"
            aria-label="What is a temporary ID"
          >
            <cigna-icon type="question-circle"></cigna-icon>
          </button>
        </div>
        <div class="cg-margin-bottom-xs">
          <a
            target="resourcesWindow"
            style="padding: 0"
            [href]="
              '/resourceLibrary/howToRegister'
                | resourceLink: { secure: false, targetApp: 'chcp' }
                | async
            "
            [cignaTrackClicks]="[
              'trackEventDownload',
              'How to register for access',
              'ac-Login007-US1023757-Register Clicked'
            ]"
          >
            {{ 'login.form.howTo' | translate }}
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
